@if (progressService.isLoading()) {
    <du-config-detail-skeleton></du-config-detail-skeleton>
} @else {
    <du-config-detail [navigateBack]="{commands: [ConfigRouteEnum.TRANSLATIONS]}">
        <detail-header>
            @if (logoUrl && logoUrl.length > 0) {
                <img
                        [ngSrc]="logoUrl"
                        alt="{{title}} logo"
                        width="64" height="64" priority>
            }
            <div>
                <h1 class="detail-header-title">
                    {{ title }}
                </h1>
            </div>
        </detail-header>
        <detail-body>
            <p-card class="translation-detail-card">
                <div class="layout-column detail-table-container">

                    <div class="detail-table-header responsive-layout">
                        <div class="detail-table-header-left">
                            <p-iconfield>
                                <p-inputicon class="pi pi-search"/>
                                <input pInputText [placeholder]="'search' | translate" [formControl]="searchInput">
                            </p-iconfield>
                            <p-select [(ngModel)]="selectedLanguage" [options]="languageOptions" optionLabel="label" optionValue="value"/>
                        </div>
                        <div class="detail-table-header-actions">
                            <p-button (click)="addTranslation()">
                                <i class="pi pi-plus"></i>
                                {{ 'translation.add' | translate | uppercase }}
                            </p-button>
                        </div>
                    </div>

                    <div>
                        <p-table [value]="filteredDataSource" [(selection)]="selection"
                                 [paginator]="true" [rows]="10" [rowsPerPageOptions]="[10, 25, 100]" sortMode="single">
                            <ng-template #header>
                                <tr>
                                    <th class="detail-table-header-cell">
                                        <p-tableHeaderCheckbox/>
                                    </th>
                                    <th pSortableColumn="identification" class="detail-table-header-cell">
                                        {{ 'translation.identification' | translate }}
                                        <p-sortIcon field="identification"/>
                                    </th>
                                    <th pSortableColumn="tenantName" class="detail-table-header-cell">
                                        {{ 'translation.language' | translate }}
                                        <p-sortIcon field="tenantName"/>
                                    </th>
                                    <th pSortableColumn="applicationSettings" class="detail-table-header-cell">
                                        {{ 'translation.translation' | translate }}
                                        <p-sortIcon field="applicationSettings"/>
                                    </th>
                                    <th pSortableColumn="active" class="detail-table-header-cell">
                                        {{ 'translation.status' | translate }}
                                        <p-sortIcon field="active"/>
                                    </th>
                                </tr>
                            </ng-template>
                            <ng-template #body let-row>
                                <tr class="detail-table-row-click" (click)="translationEdit(row)" (keydown.enter)="translationEdit(row)">
                                    <td class="detail-table-body-cell" (click)="$event.stopPropagation()">
                                        <p-tableCheckbox [value]="row"/>
                                    </td>
                                    <td class="detail-table-body-cell">{{ row.identification }}</td>
                                    <td class="detail-table-body-cell">{{ 'translation.' + row.tenantName | translate }}</td>
                                    <td class="detail-table-body-cell">{{ row.applicationSettings }}</td>
                                    <td class="detail-table-body-cell">{{ 'translation.' + row.active | translate }}</td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>
                </div>
            </p-card>
        </detail-body>
    </du-config-detail>
}
